import store from "../../store";
// import { BASE_API } from '@/const'
const router = [
  {
    path: "/login",
    name: "login",
    module: "Login",
    meta: {
      analyticsIgnore: true
    },
    component: () => import("./pages/Login"),
    beforeEnter: (to, from, next) => {
      if (to.query.token) {
        // cleanup flag/info/user
        store.commit("user/logout");
        store.commit("user/setToken", to.query);
        // if (store.getters['user/lastURL']) {
        //   // window.location.href = `${window.location.origin}${store.commit('user/popLastURL')}`
        //   const u = store.getters['user/lastURL']
        //   store.commit('user/delLastURL')
        //   next({ path: u })
        //   return
        // }
        next({
          name: "instansi.pilih"
        });
      }
      // jika sudah login, maka redirect ke home
      if (to.name == "login" && store.getters["user/check"]) {
        next({
          name: "beranda"
        });
      } else {
        // window.location.href = BASE_API
        // redirect ke halaman login api
        next();
      }
    }
  },
  // {
  //   path: "/",
  //   name: "pengguna",
  //   module: "Kelola Pengguna",
  //   meta: {
  //     auth: true,
  //     module: "Kelola Pengguna"
  //   },
  //   component: () => import("./pages/List.vue")
  // },
  {
    path: "/403",
    name: "no-akses",
    module: "Akses Tidak Tersedia",
    meta: {
      auth: false,
      module: "Akses Tidak Tersedia"
    },
    component: () => import("./pages/NoAccess.vue")
  },
  {
    path: "/instansi/:instansi_id/pengguna",
    name: "pengguna",
    module: "Kelola Pengguna",
    meta: {
      auth: true,
      module: "Kelola Pengguna"
    },
    component: () => import("./pages/List.vue")
  },
  {
    path: "/pencarian",
    name: "pencarian",
    module: "Pencarian Pengguna",
    meta: {
      auth: true,
      module: "Pencarian Pengguna"
    },
    component: () => import("./pages/PencarianPengguna.vue")
  },
  {
    path: "/instansi/:instansi_id/diklat/:diklat_id/pengguna",
    name: "pengguna.diklat",
    module: "Daftar Pengguna",
    meta: {
      auth: true,
      module: "Daftar Pengguna"
    },
    component: () => import("./pages/PenggunaDiklat.vue")
  },
  {
    path: "/instansi/:instansi_id/fasil-dosen",
    name: "fasil-dosen",
    module: "Daftar Fasil Dosen",
    meta: {
      auth: true,
      module: "Daftar Fasil Dosen"
    },
    component: () => import("./pages/FasilDosen.vue")
  },
  {
    path: "/instansi/:instansi_id/fasil-gp",
    name: "fasil-gp",
    module: "Daftar Fasil GP",
    meta: {
      auth: true,
      module: "Daftar Fasil GP"
    },
    component: () => import("./pages/FasilGP.vue")
  },
  {
    path: "/instansi/:instansi_id/fasil-inti",
    name: "fasil-inti",
    module: "Daftar Fasil Inti",
    meta: {
      auth: true,
      module: "Daftar Fasil Inti"
    },
    component: () => import("./pages/FasilInti.vue")
  },
  {
    path: "/admin-lms/:instansi_id",
    name: "admin-lms",
    module: "Daftar Admin LMS",
    meta: {
      auth: true,
      module: "Daftar Admin LMS"
    },
    component: () => import("./pages/AdminLMS.vue")
  },
  {
    path: "/instansi/:instansi_id/profil",
    name: "profil",
    meta: {
      module: "Kelola Pengguna",
      auth: true
    },
    component: () => import("./pages/Profile.vue")
  },
  {
    path: "/verifikasi",
    name: "user.activation",
    meta: {
      module: "Kelola Pengguna",
      auth: false
    },
    component: () => import("./pages/Activation.vue")
  },
  {
    path: "/lupapassword",
    name: "user.resetpassword",
    meta: {
      module: "Kelola Pengguna",
      auth: false
    },
    component: () => import("./pages/ResetPassword.vue")
  }
];

export default router;
